export default "__VITE_ASSET__DWtB2MbQ__"